// extracted by mini-css-extract-plugin
export default {"eventTitleContainer":"Title_eventTitleContainer--A0O","eventTitle":"Title_eventTitle--iA3","sportIcon":"Title_sportIcon--T7p"};